<!-- <span class="heading">{{heading.title}}</span>
<h2>{{heading.heading}}</h2>
<p>{{heading.content}}</p> -->

<div class="heading heading1 text-center container">
    <ng-content></ng-content>
</div>